import React from "react";

import UploadsGrid from "core/UploadsGrid";
import ItemContent from "./ItemContent";
import IndividualUploadLoader from "./IndividualUploadLoader";

import { useSelect } from "../PhotoUpload/hooks/useSelect";

import { convertPxToRem } from "frontend/components/helpers";

import {
    usePhotoUploadPreviewData,
    usePhotoUploadsInDropzone,
    useUploadsCurrentlyProcessing
} from "../PhotoUploadCore/hooks";

const PhotoUploadDropzoneGrid = () => {
    const { handleItemContentChange } = useSelect();
    const { uploads = [] } = usePhotoUploadsInDropzone();
    const { getUploadPreview } = usePhotoUploadPreviewData();
    const { count: currentlyProcessingCount } = useUploadsCurrentlyProcessing();

    const uploadPreviews = uploads.map((upload, index) => {
        const uploadPreview = getUploadPreview(upload.id);

        if (!uploadPreview) return null;

        return (
            <ItemContent
                key={upload.id}
                id={upload.id}
                name={upload.photoTitle || upload.originalFilename}
                preview={uploadPreview.preview}
                gridIndex={index}
                handleItemContentChange={handleItemContentChange}
            />
        );
    });

    const loaders =
        currentlyProcessingCount > 0
            ? new Array(currentlyProcessingCount).fill(
                  <IndividualUploadLoader />
              )
            : [];
    const content = [...uploadPreviews, ...loaders];

    return (
        <UploadsGrid
            numberOfColumns={5}
            gridSpacingSize={convertPxToRem({ px: 24 })}
            gridItemContent={content}
        />
    );
};

export default PhotoUploadDropzoneGrid;
